<template>
    <div v-if="showInitialLoader" class="widgetLoader">
        <div>
            <spinner-element :height="40" :width="40" style="margin-bottom: 30px;"/>
            <div style="font-size: 14px;">Powered by <a href="https://immoparse.be" target="_blank" rel="external">ImmoParse</a></div>
        </div>
    </div>
    <div v-else-if="initError" class="widgetLoader">
        <div>
            {{ initError }}
        </div>
    </div>
    <div v-else class="widget-container">
        <div class="header">
            <step-progress-bar :steps="[gettext('Locatie & type'), gettext('Contact'), gettext('Resultaat')]"
                               :active-step="selectedView"
                               @step-selected="handleStepSelected"
            />
        </div>
        <div class="content">
            <div v-if="globalMessages.length" class="globalMessagesContainer">
                <div v-for="(message, index) in globalMessages" :key="index" class="error">{{ message }}</div>
            </div>
            <transition name="fade"
                        mode="out-in">
                <div v-if="selectedView === 0">
                    <form class="widget">
                        <TextSelectInputField :label="gettext('Postcode en gemeente')"
                                              :value="this.zipcode"
                                              @update="updateZipcode"
                                              :required="true"
                                              :empty-msg="gettext('Geen resultaten gevonden')"/>
                        <div class="streetNumberContainer">
                            <TextInputAutocomplete :label="gettext('Straat en nummer')"
                                                   :value="this.streetNumber"
                                                   @updateStreetNumber="updateStreetNumber"
                                                   :zipcode="this.zipcode"
                                                   :required="true"/>
                            <TextInput :label="gettext('Bus')" :id="'boxNumber'" v-model="boxNumber" :required="!isHouse"></TextInput>
                        </div>
                        <div class="radioSelect">
                            <p>{{ gettext('Type goed') }}</p>
                            <div class="options">
                                <div class="option" :class="{selected: isHouse}" @click="toggleType(true)" tabindex="0" role="button">
                                    <svg viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z"
                                              fill="#292D32"/>
                                        <path d="M3.7002 21.9997H2.2002L2.25019 9.96971C2.25019 9.11971 2.6402 8.32974 3.3102 7.80974L10.3102 2.35973C11.3002 1.58973 12.6902 1.58973 13.6902 2.35973L20.6902 7.79973C21.3502 8.31973 21.7502 9.12971 21.7502 9.96971V21.9997H20.2502V9.97972C20.2502 9.59972 20.0702 9.22973 19.7702 8.98973L12.7702 3.54973C12.3202 3.19973 11.6902 3.19973 11.2302 3.54973L4.23019 8.99974C3.93019 9.22974 3.75019 9.59972 3.75019 9.97972L3.7002 21.9997Z"
                                              fill="#292D32"/>
                                        <path d="M14.5 22.75H9.5C9.09 22.75 8.75 22.41 8.75 22V18.5C8.75 17.26 9.76 16.25 11 16.25H13C14.24 16.25 15.25 17.26 15.25 18.5V22C15.25 22.41 14.91 22.75 14.5 22.75ZM10.25 21.25H13.75V18.5C13.75 18.09 13.41 17.75 13 17.75H11C10.59 17.75 10.25 18.09 10.25 18.5V21.25Z"
                                              fill="#292D32"/>
                                        <path d="M9.5 14.5H7.5C6.54 14.5 5.75 13.71 5.75 12.75V11.25C5.75 10.29 6.54 9.5 7.5 9.5H9.5C10.46 9.5 11.25 10.29 11.25 11.25V12.75C11.25 13.71 10.46 14.5 9.5 14.5ZM7.5 11C7.36 11 7.25 11.11 7.25 11.25V12.75C7.25 12.89 7.36 13 7.5 13H9.5C9.64 13 9.75 12.89 9.75 12.75V11.25C9.75 11.11 9.64 11 9.5 11H7.5Z"
                                              fill="#292D32"/>
                                        <path d="M16.5 14.5H14.5C13.54 14.5 12.75 13.71 12.75 12.75V11.25C12.75 10.29 13.54 9.5 14.5 9.5H16.5C17.46 9.5 18.25 10.29 18.25 11.25V12.75C18.25 13.71 17.46 14.5 16.5 14.5ZM14.5 11C14.36 11 14.25 11.11 14.25 11.25V12.75C14.25 12.89 14.36 13 14.5 13H16.5C16.64 13 16.75 12.89 16.75 12.75V11.25C16.75 11.11 16.64 11 16.5 11H14.5Z"
                                              fill="#292D32"/>
                                        <path d="M19.0001 7.75C18.5901 7.75 18.2501 7.42001 18.2501 7.01001L18.2301 4.75H14.5801C14.1701 4.75 13.8301 4.41 13.8301 4C13.8301 3.59 14.1701 3.25 14.5801 3.25H18.9801C19.3901 3.25 19.7301 3.57999 19.7301 3.98999L19.7601 6.98999C19.7501 7.40999 19.4201 7.75 19.0001 7.75C19.0101 7.75 19.0001 7.75 19.0001 7.75Z"
                                              fill="#292D32"/>
                                    </svg>
                                    <span>{{ gettext('Huis') }}</span>
                                </div>
                                <div class="option" :class="{selected: isHouse !== null && !isHouse}" tabindex="0" role="button"
                                     @click="toggleType(false)">
                                    <svg viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M23 22.75H1C0.59 22.75 0.25 22.41 0.25 22C0.25 21.59 0.59 21.25 1 21.25H23C23.41 21.25 23.75 21.59 23.75 22C23.75 22.41 23.41 22.75 23 22.75Z"
                                              fill="#292D32"/>
                                        <path d="M19.7803 22.7598C19.3703 22.7598 19.0303 22.4198 19.0303 22.0098V17.5498C19.0303 17.1398 19.3703 16.7998 19.7803 16.7998C20.1903 16.7998 20.5303 17.1398 20.5303 17.5498V22.0098C20.5303 22.4198 20.2003 22.7598 19.7803 22.7598Z"
                                              fill="#292D32"/>
                                        <path d="M19.7996 18.2999C18.1696 18.2999 16.8496 16.9799 16.8496 15.3499V13.0799C16.8496 11.4499 18.1696 10.1299 19.7996 10.1299C21.4296 10.1299 22.7496 11.4499 22.7496 13.0799V15.3499C22.7496 16.9799 21.4296 18.2999 19.7996 18.2999ZM19.7996 11.6399C18.9996 11.6399 18.3496 12.2899 18.3496 13.0899V15.3599C18.3496 16.1599 18.9996 16.8099 19.7996 16.8099C20.5996 16.8099 21.2496 16.1599 21.2496 15.3599V13.0899C21.2496 12.2899 20.5996 11.6399 19.7996 11.6399Z"
                                              fill="#292D32"/>
                                        <path d="M14.2998 22.7498C13.8898 22.7498 13.5498 22.4098 13.5498 21.9998V6.02979C13.5498 4.43979 12.8798 3.75977 11.3198 3.75977H5.08984C3.51984 3.75977 2.83984 4.43979 2.83984 6.02979V21.9998C2.83984 22.4098 2.49984 22.7498 2.08984 22.7498C1.67984 22.7498 1.33984 22.4098 1.33984 21.9998V6.02979C1.33984 3.59979 2.66984 2.25977 5.08984 2.25977H11.3198C13.7298 2.25977 15.0498 3.59979 15.0498 6.02979V21.9998C15.0498 22.4098 14.7098 22.7498 14.2998 22.7498Z"
                                              fill="#292D32"/>
                                        <path d="M10.7498 9H5.7998C5.3898 9 5.0498 8.66 5.0498 8.25C5.0498 7.84 5.3898 7.5 5.7998 7.5H10.7498C11.1598 7.5 11.4998 7.84 11.4998 8.25C11.4998 8.66 11.1598 9 10.7498 9Z"
                                              fill="#292D32"/>
                                        <path d="M10.7498 12.75H5.7998C5.3898 12.75 5.0498 12.41 5.0498 12C5.0498 11.59 5.3898 11.25 5.7998 11.25H10.7498C11.1598 11.25 11.4998 11.59 11.4998 12C11.4998 12.41 11.1598 12.75 10.7498 12.75Z"
                                              fill="#292D32"/>
                                        <path d="M8.25 22.75C7.84 22.75 7.5 22.41 7.5 22V18.25C7.5 17.84 7.84 17.5 8.25 17.5C8.66 17.5 9 17.84 9 18.25V22C9 22.41 8.66 22.75 8.25 22.75Z"
                                              fill="#292D32"/>
                                    </svg>
                                    <span>{{ gettext('Appartement') }}</span>
                                </div>
                            </div>
                        </div>
                        <SelectInput :label="selectedSubType.label"
                                     :id="selectedSubType.id"
                                     :required="selectedSubType.required"
                                     v-model="selectedSubType.value"
                                     :options="formattedSubTypeOptions"
                                     :tooltip="selectedSubType.tooltip"
                                     :disabled="isHouse === null"
                                     :placeholder="selectedSubType.placeholder"
                        />
                    </form>
                </div>
                <div v-else-if="selectedView === 1">
                    <form class="widget">
                        <TextInput :label="gettext('Voornaam')" :id="'firstName'" v-model="firstName" :required="true" v-if="askName"></TextInput>
                        <TextInput :label="gettext('Familienaam')" :id="'lastName'" v-model="lastName" :required="true" v-if="askName"></TextInput>
                        <EmailInput :label="gettext('Email')"
                                    :id="'email'"
                                    v-model="emailaddress"
                                    :required="true"
                                    :error-msg="errorMsgEmail"></EmailInput>
                        <TextInput :label="gettext('Telefoon')" :id="'phoneNumber'" v-model="phoneNumber" :required="false" :error-msg="errorMsgPhoneNumber" v-if="askPhoneNumber"></TextInput>
                        <div v-if="askIsOwner" class="isOwnerContainer radioSelect">
                            <p>{{ gettext('Bent u de eigenaar?') }}</p>
                            <div class="options">
                                <div @click="toggleIsOwner(true)" class="option" :class="{selected: isOwner}" tabindex="0" role="button">
                                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.17916 22.7499C6.07916 22.7499 5.96916 22.7399 5.87916 22.7299L3.70916 22.4299C2.66916 22.2899 1.72916 21.3599 1.56916 20.2999L1.26916 18.1099C1.16916 17.4099 1.46916 16.4999 1.96916 15.9899L6.35916 11.5999C5.64916 8.75992 6.46916 5.75992 8.55916 3.68992C11.7992 0.459923 17.0692 0.449923 20.3192 3.68992C21.8892 5.25992 22.7492 7.34992 22.7492 9.56992C22.7492 11.7899 21.8892 13.8799 20.3192 15.4499C18.2192 17.5299 15.2292 18.3499 12.4092 17.6299L8.00916 22.0199C7.58916 22.4599 6.83916 22.7499 6.17916 22.7499ZM14.4292 2.75992C12.6792 2.75992 10.9392 3.41992 9.60916 4.74992C7.80916 6.53992 7.15916 9.15992 7.90916 11.5999C7.98916 11.8699 7.91916 12.1499 7.71916 12.3499L3.01916 17.0499C2.84916 17.2199 2.70916 17.6599 2.73916 17.8899L3.03916 20.0799C3.09916 20.4599 3.50916 20.8899 3.88916 20.9399L6.06916 21.2399C6.30916 21.2799 6.74916 21.1399 6.91916 20.9699L11.6392 16.2599C11.8392 16.0599 12.1292 15.9999 12.3892 16.0799C14.7992 16.8399 17.4292 16.1899 19.2292 14.3899C20.5092 13.1099 21.2192 11.3899 21.2192 9.56992C21.2192 7.73992 20.5092 6.02992 19.2292 4.74992C17.9292 3.42992 16.1792 2.75992 14.4292 2.75992Z" fill="#292D32"/>
                                        <path d="M9.19008 20.5399C9.00008 20.5399 8.81008 20.4699 8.66008 20.3199L6.36008 18.0199C6.07008 17.7299 6.07008 17.2499 6.36008 16.9599C6.65008 16.6699 7.13008 16.6699 7.42008 16.9599L9.72008 19.2599C10.0101 19.5499 10.0101 20.0299 9.72008 20.3199C9.57008 20.4699 9.38008 20.5399 9.19008 20.5399Z" fill="#292D32"/>
                                        <path d="M14.5 11.75C13.26 11.75 12.25 10.74 12.25 9.5C12.25 8.26 13.26 7.25 14.5 7.25C15.74 7.25 16.75 8.26 16.75 9.5C16.75 10.74 15.74 11.75 14.5 11.75ZM14.5 8.75C14.09 8.75 13.75 9.09 13.75 9.5C13.75 9.91 14.09 10.25 14.5 10.25C14.91 10.25 15.25 9.91 15.25 9.5C15.25 9.09 14.91 8.75 14.5 8.75Z" fill="#292D32"/>
                                    </svg>
                                    <span>{{ gettext('Ik ben eigenaar') }}</span>
                                </div>
                                <div @click="toggleIsOwner(false)" class="option" :class="{selected: isOwner !== null && !isOwner}" tabindex="0" role="button">
                                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 10.75C17.59 10.75 17.25 10.41 17.25 10V8C17.25 4.85 16.36 2.75 12 2.75C7.64 2.75 6.75 4.85 6.75 8V10C6.75 10.41 6.41 10.75 6 10.75C5.59 10.75 5.25 10.41 5.25 10V8C5.25 5.1 5.95 1.25 12 1.25C18.05 1.25 18.75 5.1 18.75 8V10C18.75 10.41 18.41 10.75 18 10.75Z" fill="#292D32"/>
                                        <path d="M12 19.25C10.21 19.25 8.75 17.79 8.75 16C8.75 14.21 10.21 12.75 12 12.75C13.79 12.75 15.25 14.21 15.25 16C15.25 17.79 13.79 19.25 12 19.25ZM12 14.25C11.04 14.25 10.25 15.04 10.25 16C10.25 16.96 11.04 17.75 12 17.75C12.96 17.75 13.75 16.96 13.75 16C13.75 15.04 12.96 14.25 12 14.25Z" fill="#292D32"/>
                                        <path d="M17 22.75H7C2.59 22.75 1.25 21.41 1.25 17V15C1.25 10.59 2.59 9.25 7 9.25H17C21.41 9.25 22.75 10.59 22.75 15V17C22.75 21.41 21.41 22.75 17 22.75ZM7 10.75C3.42 10.75 2.75 11.43 2.75 15V17C2.75 20.57 3.42 21.25 7 21.25H17C20.58 21.25 21.25 20.57 21.25 17V15C21.25 11.43 20.58 10.75 17 10.75H7Z" fill="#292D32"/>
                                    </svg>
                                    <span>{{ gettext('Ik ben geen eigenaar') }}</span>
                                </div>
                            </div>
                        </div>
                        <SelectInput v-if="askIsSelling"
                                     :id="'isSelling'"
                                     :label="isSelling.label"
                                     v-model="isSelling.value"
                                     :options="isSelling.options"
                        />
                        <CheckboxField :label="gettext('Ik ga akkoord met de')"
                                       :id="'privacyAgreement'"
                                       v-model:checked="privacyAgreement"
                                       :required="true"
                                       :privacyUrl="'/privacy'"
                                       :privacyText="gettext('privacyverklaring')"
                                       :termsAndConditionsUrl="'/conditions'"
                                       :termsAndConditions="gettext('algemene voorwaarden')"></CheckboxField>
                    </form>
                </div>
                <div v-else-if="selectedView === 2" class="viewContainer">
                    <div>
                        <div class="results-container">
                            <OpenlayersMapElement :lat="lat" :lng="lng"
                                                  :comparisonPoints="compPoints"
                                                  :strokeColor="accentColorHex"
                                                  :fillColor="primaryColorHex"
                                                  :showMarker="showMarker"
                                                  :zoomLevel="zoomLevel"
                                                  :responsiveConfig="{'650': {padding: [75, 20, 200, 20]}, '415': {padding: [95, 20, 200, 20]}}"
                                                  :stylesheet="stylesheet"
                                                  :locale="locale"></OpenlayersMapElement>
                            <div class="results-map">
                                <div class="results-location">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.9989 14.1714C9.86891 14.1714 8.12891 12.4414 8.12891 10.3014C8.12891 8.16141 9.86891 6.44141 11.9989 6.44141C14.1289 6.44141 15.8689 8.17141 15.8689 10.3114C15.8689 12.4514 14.1289 14.1714 11.9989 14.1714ZM11.9989 7.94141C10.6989 7.94141 9.62891 9.00141 9.62891 10.3114C9.62891 11.6214 10.6889 12.6814 11.9989 12.6814C13.3089 12.6814 14.3689 11.6214 14.3689 10.3114C14.3689 9.00141 13.2989 7.94141 11.9989 7.94141Z"
                                              fill="#292D32"/>
                                        <path d="M12.0016 22.76C10.5216 22.76 9.03164 22.2 7.87164 21.09C4.92164 18.25 1.66164 13.72 2.89164 8.33C4.00164 3.44 8.27164 1.25 12.0016 1.25C12.0016 1.25 12.0016 1.25 12.0116 1.25C15.7416 1.25 20.0116 3.44 21.1216 8.34C22.3416 13.73 19.0816 18.25 16.1316 21.09C14.9716 22.2 13.4816 22.76 12.0016 22.76ZM12.0016 2.75C9.09164 2.75 5.35164 4.3 4.36164 8.66C3.28164 13.37 6.24164 17.43 8.92164 20C10.6516 21.67 13.3616 21.67 15.0916 20C17.7616 17.43 20.7216 13.37 19.6616 8.66C18.6616 4.3 14.9116 2.75 12.0016 2.75Z"
                                              fill="#292D32"/>
                                    </svg>
                                    <div>
                                        <div>{{ streetNumber }} {{ boxNumber }}</div>
                                        <div>-</div>
                                        <div>{{ zipcode }}</div>
                                    </div>
                                </div>
                                <div class="results-details">
                                    <div class="details" v-if="!addressError">
                                        <h4 v-if="estimatedValueCardTitle">{{ estimatedValueCardTitle }}</h4>
                                        <h4 v-else>{{ gettext('Geschatte waarde') }}</h4>
                                        <transition name="fade"
                                                    mode="out-in">
                                            <div v-if="isLoading">
                                                <spinner-element/>
                                            </div>
                                            <div v-else-if="valuationError" style="font-size: 16px;">
                                                {{ gettext('Zijn de kenmerken juist? Zo ja, dan is een automatische schatting niet mogelijk.') }}
                                            </div>
                                            <div v-else>
                                                <transition name="fade"
                                                            mode="out-in">
                                                    <span :key="marketValueMinFormatted">{{
                                                        marketValueMinFormatted
                                                        }}</span>
                                                </transition>
                                                -
                                                <transition name="fade"
                                                            mode="out-in">
                                                    <span :key="marketValueMaxFormatted">{{
                                                        marketValueMaxFormatted
                                                        }}</span>
                                                </transition>
                                            </div>
                                        </transition>
                                        <div v-if="showContactContainer" class="contact">
                                            <transition name="fade" mode="out-in">
                                                <div v-if="contactRequested" class="contact-text">
                                                    <span v-if="contactRequestedMessage">{{ contactRequestedMessage }}</span>
                                                    <span v-else>
                                                        {{ gettext('Dank voor je interesse! Eén van onze experten contacteert je spoedig. In een persoonlijk adviesgesprek valideren we vrijblijvend en gratis de schatting.') }}
                                                    </span>
                                                </div>
                                                <a v-else class="button button-primary" @click="contactMe" tabindex="0" role="button">
                                                    <span v-if="contactMeButton">{{ contactMeButton }}</span>
                                                    <span v-else>{{ gettext('Contacteer mij') }}</span>
                                                </a>
                                            </transition>
                                            <div style="font-size: 10px; margin-top: 10px;">
                                                powered by <a href="https://immoparse.be" target="_blank" rel="external" style="color: #02a19a;">ImmoParse</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="extraOptionsContainer">
                            <form class="widget">
                                <p v-if="extraOptionsSubtitle">{{ extraOptionsSubtitle }}</p>
                                <p v-else>{{ gettext('Verfijn de schatting door de kenmerken aan te vullen.') }}</p>
                                <component v-for="field in lastOrderParams"
                                           :key="field.key"
                                           :is="field.component"
                                           :label="field.label"
                                           :required="field.required"
                                           v-model="field.value"
                                           :min="field.min"
                                           :max="field.max"
                                           :options="field.options"
                                           :unit="field.unit"
                                           :tooltip="field.tooltip"
                                           :error="field.error"
                                           @initiate-recalculation="initiateRecalculation"
                                           :placeholder="field.placeholder"
                                           :id="field.id"
                                >
                                </component>
                            </form>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div class="footer">
            <a v-if="selectedView === 1 || selectedView === 2" @click="prevView"
               class="button button-secondary" tabindex="0" role="button">{{ gettext('Terug') }}</a>
            <a v-if="selectedView === 0" @click="initiateCalculation" class="button button-primary"
               :class="{disabled: !addressComplete, buttonLoading: isLoading}" tabindex="0" role="button">
                <transition name="fade"
                            mode="out-in">
                    <span v-if="isLoading">
                        <spinner-element/>
                    </span>
                    <span v-else-if="proceedButton">{{ proceedButton }}</span>
                    <span v-else>{{ gettext('Volgende') }}</span>
                </transition>
            </a>
            <a v-if="selectedView === 1" @click="processContactDetails"
               class="button button-primary" :class="{disabled: !contactDetailsComplete, buttonLoading: isLoading}"
               tabindex="0" role="button">
                <transition name="fade"
                            mode="out-in">
                    <span v-if="isLoading">
                        <spinner-element/>
                    </span>
                    <span v-else-if="estimateButton">{{ estimateButton }}</span>
                    <span v-else>{{ gettext('Schatten') }}</span>
                </transition>
            </a>
            <a v-if="selectedView === 2" @click="recalculateEstimateOnClick"
               class="button button-primary" :class="{disabled: addressError, buttonLoading: isLoading}"
               tabindex="0" role="button">
                <transition name="fade"
                            mode="out-in">
                    <span v-if="isLoading">
                        <spinner-element/>
                    </span>
                    <span v-else-if="recalculateButton">{{ recalculateButton }}</span>
                    <span v-else>{{ gettext('Herbereken') }}</span>
                </transition>
            </a>
        </div>
    </div>
</template>

<script>
import {defineComponent, computed, ref, reactive, onMounted, watch} from 'vue';
import LeadsAPI from '@/api/resources/leads';
import TextInput from "@/components/leadswidget/TextInput";
import TextInputAutocomplete from "@/components/leadswidget/TextInputAutocomplete";
import EmailInput from "@/components/leadswidget/EmailInput";
import SelectField from "@/components/leadswidget/SelectField";
import SelectInput from "@/components/leadswidget/SelectInput.vue";
import CheckboxField from "@/components/leadswidget/CheckboxField";
import NumberInput from "@/components/leadswidget/NumberInput";
import TextSelectInputField from "@/components/leadswidget/TextSelectInput";
import StepProgressBar from "@/components/leadswidget/StepProgressBar";
import SpinnerElement from "@/components/SpinnerElement";
import OpenlayersMapElement from "@/components/leadswidget/OpenlayersMapElement";
import {currencyFormatter, generateValueOptions, splitAddress} from '@/pages/leadwidget/helpers'
import {useGettext} from "vue3-gettext";
import {establishConnection} from "@/pages/leadwidget/eventSourceConnection";

export default defineComponent({
    name: 'LeadWidget',
    components: {
        TextSelectInputField,
        NumberInput,
        CheckboxField,
        SelectField,
        TextInput,
        TextInputAutocomplete,
        EmailInput,
        StepProgressBar,
        SelectInput,
        SpinnerElement,
        OpenlayersMapElement
    },
    props: {
        locale: {
            type: String,
            required: true,
        },
        api_key: {
            type: String,
            required: true
        }
    },
    setup(props) {
        // translations
        const {$gettext} = useGettext();
        const gettext = $gettext;

        // form functioning
        const showInitialLoader = ref(true)
        const initError = ref('')
        const selectedView = ref(0)
        const isLoading = ref(false)
        const showContactContainer = ref(true)

        // customized options by user (if any)
        const primaryColorHex = ref('')
        const accentColorHex = ref('')

        // custom user defined text
        const contactRequestedMessage = ref('')
        const extraOptionsSubtitle = ref('')
        const contactMeButton = ref('')
        const proceedButton = ref('')
        const estimateButton = ref('')
        const recalculateButton = ref('')
        const estimatedValueCardTitle = ref('')

        const initWidget = async () => {
            try {
                let data = await LeadsAPI.get(props.api_key);
                selectedSubType.options = data.sub_type_options
                params.value.forEach(param => {
                    if (param.key === 'selectedHabType') {
                        param.options = data.hab_type_options;
                    } else if (param.key === 'selectedFinishing') {
                        param.options = data.finishing_options;
                    } else if (param.key === 'selectedCondition') {
                        param.options = data.condition_options;
                    }
                });

                // user defined options
                askName.value = data.ask_name
                askPhoneNumber.value = data.ask_phone_number
                checkPhoneNumber.value = data.check_phone_number
                askIsOwner.value = data.ask_is_owner
                askIsSelling.value = data.ask_is_selling
                isSelling.options = data.is_selling_options
                primaryColorHex.value = data.primary_color_hex
                accentColorHex.value = data.accent_color_hex
                contactRequestedMessage.value = data.contact_requested_message
                extraOptionsSubtitle.value = data.extra_options_subtitle
                contactMeButton.value = data.contact_me_button
                proceedButton.value = data.proceed_button
                estimateButton.value = data.estimate_button
                recalculateButton.value = data.recalculate_button
                estimatedValueCardTitle.value = data.estimated_value_card_title

                const defaultCssUrl = '/static/css/leads/ip.css';
                const cssUrl = data.stylesheet ? `/static/css/leads/${data.stylesheet}.css` : data.customCss || defaultCssUrl;

                // custom css
                const cssLoaded = new Promise((resolve) => {
                  const link = document.createElement('link');
                  link.rel = 'stylesheet';
                  link.href = cssUrl;
                  link.onload = resolve;  // Resolve the Promise when the CSS has loaded
                  document.head.appendChild(link);
                });
                await cssLoaded;
            } catch (error) {
                initError.value = gettext('De schattingswidget kon niet worden geïnitialiseerd.')
            } finally {
                showInitialLoader.value = false;
            }
        };

        // map vars
        const showMarker = ref(true)
        const zoomLevel = ref(10)

        // widget flow vars
        const currentView = computed(() => selectedView.value + 1)
        const prevView = () => {
            selectedView.value--
        }

        // subtypes fields config
        const isHouse = ref(null)
        const toggleType = (bool) => {
            selectedSubType.value = null
            isHouse.value = bool
        }
        const formattedSubTypeOptions = computed(() => {
            let options = []
            if (isHouse.value) {
                options = selectedSubType.options[0][1]
            }

            if (isHouse.value !== null && !isHouse.value) {
                options = selectedSubType.options[1][1]
            }
            return options
        })

        // listing address
        const zipcode = ref('')
        const streetNumber = ref('')
        const boxNumber = ref('')
        const lat = ref(50.5010789)
        const lng = ref(4.4764595)
        const compPoints = ref([])

        const updateZipcode = (val) => {
            zipcode.value = val
        }
        const updateStreetNumber = (val) => {
            streetNumber.value = val
        }

        // lead details
        const firstName = ref('')
        const lastName = ref('')
        const emailaddress = ref('')
        const privacyAgreement = ref(false)
        const sessionID = ref(null)
        const contactRequested = ref(false)

        // optional lead fields - user defined
        const askName = ref(false)
        const askPhoneNumber = ref(false)
        const checkPhoneNumber = ref(false)
        const phoneNumber = ref(null)
        const askIsOwner = ref(false)
        const isOwner = ref(null)
        const askIsSelling = ref(false)
        const isSelling = reactive({
            component: 'SelectField',
            value: null,
            key: 'isSelling',
            label: gettext('Wenst u te verkopen?'),
            options: [],
        })
        const toggleIsOwner = (bool) => {
            isOwner.value = bool
        }

        const resetFields = () => {
            sessionID.value = ''
            contactRequested.value = false
            marketValueMin.value = null
            marketValueMax.value = null
            compPoints.value = []
            lat.value = 50.5010789
            lng.value = 4.4764595
            params.value.forEach((param) => {
                param.value = null;
                param.checked = false;
            })
            showContactContainer.value = true
        }

        // listing details
        const selectedSubType = reactive({
            component: 'SelectField',
            required: true,
            value: null,
            key: 'selectedSubType',
            label: gettext('Subtype'),
            options: [],
            error: null,
            placeholder: gettext('kies een optie'),
            id: 'subtype'
        })
        const bedrooms = reactive({
            component: 'SelectField',
            required: false,
            value: null,
            key: 'bedrooms',
            label: gettext('Slaapkamers'),
            options: generateValueOptions(6, gettext('of meer')),
            error: null,
            placeholder: gettext('selecteer een waarde'),
            id: 'bedrooms'
        })
        const bathrooms = reactive({
            component: 'SelectField',
            required: false,
            value: null,
            key: 'bathrooms',
            label: gettext('Badkamers'),
            options: generateValueOptions(5),
            error: null,
            placeholder: gettext('selecteer een waarde'),
            id: 'bathrooms'
        })
        const year = reactive({
            component: 'NumberInput',
            required: false,
            value: null,
            key: 'year',
            label: gettext('Bouwjaar'),
            max: new Date().getFullYear(),
            min: "1700",
            tooltip: gettext('Bouwjaar verwijst naar het jaar waarin een gebouw oorspronkelijk is gebouwd of bijna volledig gerenoveerd.'),
            error: null,
            id: 'year'
        })
        const selectedHabType = reactive({
            component: 'SelectField',
            required: false,
            value: null,
            key: 'selectedHabType',
            label: gettext('Type bebouwing'),
            options: [],
            error: null,
            houseOnly: true,
            placeholder: gettext('selecteer een waarde'),
            id: 'buildingType'
        })

        const conditionFormatStr = `<p><b>{}</b>: {}</p>
                            <p><b>{}</b>: {}</p>
                            <p><b>{}</b>: {}</p>
                            <p><b>{}</b>: {}</p>`;

        const conditionTranslatedArgs = [
            gettext('Te renoveren'), gettext('Een pand dat grote structurele verbeteringen nodig heeft.'),
            gettext('Op te frissen'), gettext('Het pand is bruikbaar, maar heeft op termijn enkele verbeteringen nodig.'),
            gettext('Goede staat'), gettext('Het pand is direct bruikbaar zonder grote of kleine verbeteringen, er zijn lichte gebruikssporen.'),
            gettext('Uitstekende staat'), gettext('Een nieuw, recent gerenoveerd of perfect onderhouden pand, klaar voor gebruik zonder gebruikssporen.'),
        ];
        const conditionTooltip = conditionFormatStr.replace(/\{\}/g, () => conditionTranslatedArgs.shift());

        const selectedCondition = reactive({
            component: 'SelectField',
            required: false,
            value: null,
            key: 'selectedCondition',
            label: gettext('Staat'),
            options: [],
            tooltip: conditionTooltip,
            error: null,
            placeholder: gettext('selecteer een waarde'),
            id: 'condition'
        })
        const epc = reactive({
            component: 'SelectField',
            required: false,
            value: null,
            key: 'epc',
            label: gettext('EPC-label'),
            options: [],
            tooltip: gettext('Het EPC-label toont aan hoe energiezuinig een gebouw is. Met een letter wordt de energie-efficiëntie van een gebouw aangeduid.'),
            error: null,
            placeholder: gettext('selecteer een waarde'),
            id: 'epcLabel'
        })

        const finishingFormatStr = `<p><b>{}</b>: {}</p>
                            <p><b>{}</b>: {}</p>
                            <p><b>{}</b>: {}</p>`;
        const finishingTranslatedArgs = [
            gettext('Standaard'), gettext('basis materialen, technieken en decoratie.'),
            gettext('Kwalitatief'), gettext('duurzame en hedendaagse materialen, technieken en decoratie.'),
            gettext('Luxueus'), gettext('luxueuze materialen, hoogwaardige technieken en verfijnde decoratie.'),
        ];
        const finishingTooltip = finishingFormatStr.replace(/\{\}/g, () => finishingTranslatedArgs.shift());

        const selectedFinishing = reactive({
            component: 'SelectField',
            required: false,
            value: null,
            key: 'selectedFinishing',
            label: gettext('Afwerking'),
            options: [],
            tooltip: finishingTooltip,
            error: null,
            placeholder: gettext('selecteer een waarde'),
            id: 'finishing'
        })
        const livArea = reactive({
            component: 'NumberInput',
            required: false,
            value: null,
            key: 'livArea',
            label: gettext('Vloeroppervlakte'),
            unit: 'm²',
            min: 0,
            tooltip: gettext('De vloeroppervlakte van het gebouw in vierkante meter (m²). Voor een huis kan u dit zelf uitrekenen door de bebouwde oppervlakte aan de grond te vermenigvuldigen met het aantal verdiepingen (een zolder bruikbaar als een kamer telt mee als halve verdieping).'),
            error: null,
            id: 'livArea'
        })
        const totArea = reactive({
            component: 'NumberInput',
            required: false,
            value: null,
            key: 'totArea',
            label: gettext('Grondoppervlakte'),
            unit: 'm²',
            min: 0,
            tooltip: gettext('Grondoppervlakte is het totale horizontale gebied van een perceel, gemeten op de grond, meestal uitgedrukt in vierkante meters (m²).'),
            error: null,
            id: 'totArea',
            houseOnly: true // param is only applicable to homes
        })
        const terraceArea = reactive({
            component: 'NumberInput',
            required: false,
            value: null,
            key: 'terraceArea',
            label: gettext('Terrasoppervlakte'),
            unit: 'm²',
            min: 0,
            error: null,
            id: 'terrace',
            apartmentOnly: true // param is only applicable to apartments
        })

        const allParams = [
            livArea,
            totArea,
            terraceArea,
            selectedCondition,
            selectedFinishing,
            bedrooms,
            bathrooms,
            selectedHabType,
            epc,
            year
        ]

        const params = computed(() => {
            let selectedParams = allParams
            if (selectedSubType.value) {
              let subType = parseInt(selectedSubType.value)
              if (subType >= 11 && subType <= 17) {
                selectedParams = allParams.filter(param => (!param.houseOnly || param.apartmentOnly))
              }
              else {
                selectedParams = allParams.filter(param => !param.apartmentOnly)
              }
            }
            const notFilledInFields = selectedParams.filter(field => !field.value)
            const filledInFields = selectedParams.filter(field => field.value)

            return [...notFilledInFields, ...filledInFields]
        })

        const lastKnownValues = new Map();

        // Populate lastKnownValues with initial values
        allParams.forEach(field => {
          lastKnownValues.set(field.key, field.value);
        });

        // Keep a ref to store the last known order
        const lastOrderParams = ref([...params.value])

        let delayTimeout = null;

        watch(
          params,
          (newOrder) => {
              if (delayTimeout) {
                  clearTimeout(delayTimeout);
              }

              // Check if any of the fields that changed meets the condition
              const hasDelayableField = newOrder.some((field) => {
                  const lastKnownValue = lastKnownValues.get(field.key);
                  const hasChanged = lastKnownValue !== field.value;
                  const isNumberInput = field.component === "NumberInput";

                  // Update the last known value for this field
                  lastKnownValues.set(field.key, field.value);

                  return hasChanged && isNumberInput;
              });

              const timeoutDuration = hasDelayableField ? 2000 : 500;

              delayTimeout = setTimeout(() => {
                  lastOrderParams.value = [...newOrder];
              }, timeoutDuration);

          }
        );

        const globalMessages = ref([]);
        const parameterError = ref(null);
        const addressError = ref(false);

        const contactDetailsComplete = computed(() => {
            const isEmailValid = emailaddress.value && validateEmail(emailaddress.value);
            const isFirstNameValid = askName.value ? (firstName.value && firstName.value.trim() !== '') : true;
            const isLastNameValid = askName.value ? (lastName.value && lastName.value.trim() !== '') : true;
            const isPrivacyAgreementChecked = privacyAgreement.value;
            const isPhoneNumberValid = (checkPhoneNumber.value && askPhoneNumber.value) ? !!validatePhoneNumber(phoneNumber.value) : true

            return isEmailValid && isFirstNameValid && isLastNameValid && isPrivacyAgreementChecked && isPhoneNumberValid;
        })

        const addressComplete = computed(() => {
            const isZipcodeValid = zipcode.value && zipcode.value.trim() !== '';
            const isStreetNumberValid = streetNumber.value && streetNumber.value.trim() !== '';
            const isSubTypeValid = selectedSubType.value !== null && selectedSubType.value !== undefined;

            return !!(isZipcodeValid && isStreetNumberValid && isSubTypeValid);
        });

        // domain validation for email address
        async function validateDomainExists(email) {
          const domain = email.split('@')[1];
          const mxRecords = await lookupMXRecords(domain);
          return mxRecords.length > 0;
        }

        async function lookupMXRecords(domain) {
          const response = await fetch(`https://dns.google.com/resolve?name=${domain}&type=mx`);
          const data = await response.json();
          return data.Answer || [];
        }

        // validator for emailaddress
        const errorMsgEmail = ref('');
        const validateEmail = async (email) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (email) {
                if (!emailRegex.test(email) || ! await validateDomainExists(email)) {
                  errorMsgEmail.value = gettext('Gelieve een geldig email adres in te vullen');
                } else {
                    emailaddress.value = email
                    errorMsgEmail.value = '';
                    return true
                }
            } else {
                errorMsgEmail.value = '';
            }
            return false;
        }

        // validator phoneNumber
        const errorMsgPhoneNumber = ref('')
        const validatePhoneNumber = (number) => {
            const phoneRegex = /^(((\+|00)32[ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})$/;

            if (number) {
                if (!phoneRegex.test(number)) {
                    if (number.length > 3) {
                        errorMsgPhoneNumber.value = gettext('Gelieve een geldig telefoonnummer in te vullen');
                    }
                } else {
                    phoneNumber.value = number
                    errorMsgPhoneNumber.value = '';
                    return true
                }
            } else {
                errorMsgPhoneNumber.value = '';
            }
            return false;
        }

        const marketValueMin = ref(null);
        const marketValueMax = ref(null);
        const marketValueMinFormatted = computed(() => currencyFormatter({locale: props.locale}).format(marketValueMin.value))
        const marketValueMaxFormatted = computed(() => currencyFormatter({locale: props.locale}).format(marketValueMax.value))
        const valuationError = computed(() => !marketValueMin.value && !marketValueMax.value);
        const createSession = async () => {
            let result = await LeadsAPI.post(props.api_key)
            if (!result.success) {
                alert(gettext('Er is iets mis gegaan, onze diensten zijn automatisch verwittigd van dit probleem en zullen het zo snel mogelijk oplossen.'))
            } else {
                return result.data['sessionID']
            }
        }

        const initiateCalculation = async () => {
            // TODO: below this is not ideal solution and only a temporary fix, we should refactor code and handle button clicks in dedicate function to encapsulate specific actions (Separation of Concerns)
            if (isLoading.value) {
                return
            }
            globalMessages.value = []
            if (addressComplete.value) {
                // reinitialize fields
                resetFields()
                isLoading.value = true
                // create session id
                sessionID.value = await createSession()

                // when session id is received continue
                if (sessionID.value) {
                    const eventSourceUrl = "/stream?channel=" + sessionID.value
                    const eventSource = establishConnection(eventSourceUrl, globalMessages, gettext);

                    let data = new FormData()
                    data.append('initiate', true)
                    data.append('sessionID', sessionID.value)
                    data.append('zipcode', zipcode.value)
                    data.append('streetNumber', streetNumber.value + ' ' + boxNumber.value)
                    data.append('selectedSubType', selectedSubType.value)

                    let result = await LeadsAPI.post(props.api_key, data);
                    if (!result.success) {
                        alert(gettext('Er is iets mis gegaan, onze diensten zijn automatisch verwittigd van dit probleem en zullen het zo snel mogelijk oplossen.'))
                    } else {
                        selectedView.value = 1
                        // TODO: optimization -- error handling can probably be from within 1 array + helper function that checks if any blocking errors are present)
                        globalMessages.value = []
                        addressError.value = false
                        params.value.forEach((param) => {
                            param.error = null
                        })
                        eventSource.addEventListener('avm', function (event) {
                            let res = JSON.parse(event.data)

                            if (res.errors) {
                                const fieldsToUpdate = {
                                    tot_area: "totArea",
                                    liv_area: "livArea",
                                    terrace: "terraceArea",
                                    bedrooms: "bedrooms",
                                    bathrooms: "bathrooms",
                                    year: "year",
                                    condition: "selectedCondition",
                                    epc: "epc",
                                    hab_type: "selectedHabType",
                                    finishing: "selectedFinishing",
                                };
                                params.value.forEach((param) => {
                                    param.error = null
                                })
                                res.errors.forEach((error) => {
                                    if (["PARAM_TOO_HIGH", "PARAM_TOO_LOW", "ATYPICAL_PARAM_VALUE", "INVALID_CPF_PARAM"].includes(error.code)) {
                                        parameterError.value = res.errors.map(error => [error.code, error.param]) // TODO: not sure what this is for but I kept it for now
                                        params.value.find(param => param.key === fieldsToUpdate[error.param]).error = error
                                    } else {
                                        globalMessages.value = res.errors.map((msg) => gettext(msg.translated_msg))
                                        addressError.value = res.errors.map(error => error.code === 'INVALID_ADDRESS').includes(true)
                                    }
                                })
                            }

                            if (res.comparison_points && res.comparison_points.length) {
                                let data = res.comparison_points.slice(0, 5);
                                compPoints.value = data.map((comparisonPoint) => {
                                    const [price, lng, lat] = comparisonPoint.slice(-3);
                                    return [price, lng, lat]
                                });
                            }

                            /*if (res.log) {
                              console.log(res.log);
                            }*/

                            if (res.location) {
                                streetNumber.value = res.location.streetNumber
                                if (res.location.rest) {
                                    [streetNumber.value, boxNumber.value] = splitAddress(res.location.streetNumber)
                                }
                                zipcode.value = res.location.zipcode + ' ' + res.location.placeName.split(',')[0].trim()
                                lat.value = res.location.lat
                                lng.value = res.location.lng
                                addressError.value = false
                                isLoading.value = false
                                zoomLevel.value = 14
                                showMarker.value = true
                            }

                            if (res.epcLabels) {
                                const foundParam = params.value.find(param => param.key === "epc");
                                foundParam.options = res.epcLabels['epc']
                                foundParam.options.forEach(option => {
                                    option.value = option.avg;
                                })
                            }

                            if (res.pte) {
                                const fieldsToUpdate = {
                                    totArea: "totArea",
                                    livArea: "livArea",
                                    terraceArea: "terraceArea",
                                    bedrooms: "bedrooms",
                                    bathrooms: "bathrooms",
                                    year: "year",
                                    condition: "selectedCondition",
                                    epc: "epc",
                                    habType: "selectedHabType",
                                    finishing: "selectedFinishing",
                                };

                                const getLabelValue = (value, labelArray) => {
                                    const label = labelArray.find(label => value >= label.min && value <= label.max);
                                    if (label) {
                                        return label.value
                                    }
                                    return null;
                                }

                                for (const [paramKey, reactiveKey] of Object.entries(fieldsToUpdate)) {
                                    const resValue = res.pte[paramKey];
                                    const param = params.value.find(pte => pte.key === reactiveKey);
                                    if (resValue && param) {
                                        const midValue = param.options ? getLabelValue(resValue, param.options) : null;
                                        param.value = midValue !== null ? midValue : resValue;
                                        param.checked = true;
                                    }
                                }
                            }

                            if (res.valuation) {
                                marketValueMin.value = res.valuation.min
                                marketValueMax.value = res.valuation.max
                                isLoading.value = false
                            }

                            if (res.place) {
                                lat.value = res.place.lat;
                                lng.value = res.place.lng;
                                showMarker.value = false;
                                zoomLevel.value = 12;
                            }

                            if (!res.log && marketValueMin.value) {
                                isLoading.value = false;
                            }
                        })
                    }
                }
            }
            else {
                globalMessages.value.push(gettext('Gelieve alle benodigde velden in te vullen.'))
            }
        }
        const processContactDetails = async () => {
            if (!isLoading.value) {
                globalMessages.value = []
                if (contactDetailsComplete.value && await validateEmail(emailaddress.value)) {
                    isLoading.value = true
                    let data = new FormData()
                    data.append('firstName', firstName.value)
                    data.append('lastName', lastName.value)
                    data.append('privacyAgreement', privacyAgreement.value)
                    data.append('email', emailaddress.value)
                    data.append('sessionID', sessionID.value)
                    data.append('phoneNumber', phoneNumber.value)
                    data.append('isOwner', isOwner.value)
                    data.append('isSelling', isSelling.value)

                    let result = await LeadsAPI.post(props.api_key, data);
                    if (!result.success) {
                        if (result.data['error'] === 'email_validation') {
                          errorMsgEmail.value = gettext('Dit email adres kon niet gevalideerd worden');
                        } else {
                          alert(gettext('Er is iets mis gegaan, onze diensten zijn automatisch verwittigd van dit probleem en zullen het zo snel mogelijk oplossen.'))
                        }
                    } else {
                        sessionID.value = result.data['sessionID']
                        selectedView.value++
                        if (addressError.value) {
                            globalMessages.value.push(gettext('adres onbekend'))
                            isLoading.value = false
                        }
                    }
                } else {
                    if (addressError.value) {
                        globalMessages.value.push(gettext('adres onbekend'))
                    }
                    globalMessages.value.push(gettext('Alle velden dienen ingevuld te worden alvorens door te gaan.'))
                }
                if (marketValueMin.value && marketValueMax.value) {
                    isLoading.value = false;
                }
            }
        }
        const recalculateEstimate = async () => {
            globalMessages.value = []
            isLoading.value = true
            let data = new FormData()
            data.append('sessionID', sessionID.value)

            let chars = {}
            params.value.forEach(char => {
                chars[char.key] = char.value
            })
            data.append('params', JSON.stringify(chars))
            let result = await LeadsAPI.post(props.api_key, data)
            if (!result.success) {
                alert(gettext('Er is iets mis gegaan, onze diensten zijn automatisch verwittigd van dit probleem en zullen het zo snel mogelijk oplossen.'))
            }
        }

        const recalculateEstimateOnClick = () => {
            if (!isLoading.value && !addressError.value) {
                recalculateEstimate()
            }
        }

        const contactMe = async () => {
            let data = new FormData()
            data.append('sessionID', sessionID.value)
            data.append('contactRequested', contactRequested.value)

            let result = await LeadsAPI.post(props.api_key, data)
            if (!result.success) {
                alert(gettext('Er is iets mis gegaan, onze diensten zijn automatisch verwittigd van dit probleem en zullen het zo snel mogelijk oplossen.'))
            } else {
                contactRequested.value = true;
            }
        }

        const handleStepSelected = (step) => {
            if (step < selectedView.value) {
                selectedView.value = step
            }
        }

        const initiateRecalculation = async () => {
            if (!addressError.value) {
                await recalculateEstimate()
            }
        }

        onMounted(() => {
            initWidget();
        })

        return {
            gettext,
            initWidget,
            selectedView,
            firstName,
            lastName,
            emailaddress,
            privacyAgreement,
            phoneNumber,
            isOwner,
            zipcode,
            streetNumber,
            boxNumber,
            marketValueMinFormatted,
            marketValueMaxFormatted,
            isLoading,
            errorMsgEmail,
            globalMessages,
            selectedSubType,
            bedrooms,
            bathrooms,
            year,
            selectedHabType,
            selectedCondition,
            epc,
            selectedFinishing,
            livArea,
            terraceArea,
            addressComplete,
            contactDetailsComplete,
            initiateCalculation,
            currentView,
            prevView,
            processContactDetails,
            updateZipcode,
            updateStreetNumber,
            totArea,
            lastOrderParams,
            contactMe,
            contactRequested,
            handleStepSelected,
            initiateRecalculation,
            recalculateEstimate,
            marketValueMin,
            recalculateEstimateOnClick,
            showContactContainer,
            lat,
            lng,
            compPoints,
            askName,
            askPhoneNumber,
            checkPhoneNumber,
            askIsOwner,
            toggleIsOwner,
            errorMsgPhoneNumber,
            validatePhoneNumber,
            isHouse,
            toggleType,
            formattedSubTypeOptions,
            askIsSelling,
            isSelling,
            contactRequestedMessage,
            extraOptionsSubtitle,
            contactMeButton,
            proceedButton,
            estimateButton,
            recalculateButton,
            estimatedValueCardTitle,
            primaryColorHex,
            accentColorHex,
            addressError,
            showMarker,
            zoomLevel,
            showInitialLoader,
            initError,
            valuationError
        }
    }
});
</script>


<style scoped lang="scss">
@import '@/styles/defaults.scss';
@import '@/styles/leads_widget/normalize.css';

h3, h4 {
  margin: 0;
}

div.widgetLoader {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    width: 100%;
    margin: 0;
    background-color: #fafafa;
    padding: 50px 0;
}

div.widgetLoader > div {
    text-align: center;
}

a.button {
  border-radius: 5px;
  cursor: pointer;
  display: block;
}


.button-primary {
  background-color: $primary-color;
  color: white;
  font-weight: bold;
  padding: 10px 15px;
  margin-left: auto;
}

.button-primary:hover {
  background-color: darken($primary-color, 10%);
}

a.button.button-primary.disabled {
  cursor: not-allowed;
  background-color: #007a76;
}

.button-secondary {
  background-color: transparent;
  color: #b7b7b7;
}

.content {
  margin: 5px 0 25px 0;
}

div.results-container {
  position: relative;
}

div.results-map {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  top: 0;
  width: 100%;
  pointer-events: none;
}

div.results-map > div:first-of-type {
  margin: 20px 20px 0 20px;
}

div.results-map > div:last-of-type {
  margin: 0 20px 20px 20px;
}

div.results-map > div.results-location, div.results-details > div {
  pointer-events: auto;
}

div.results-details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
}

div.results-details > div.details {
  background-color: rgba(255, 255, 255, 0.95);
  min-width: 300px;
  max-width: 350px;
  padding: 10px;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 0 0 auto;
  min-height: 97px;
}

div.results-details > div.details > div {
  font-size: 20px;
  font-variant: ordinal;
}

div.results-details > div.details > h4 {
  font-size: 14px;
}

div.results-details > div.details > div:last-of-type {
  font-size: 12px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.extraOptionsContainer > form {
  height: 250px;
  margin: 0;
  overflow: auto;
}

div.extraOptionsContainer > form > p {
  margin-top: 20px;
  margin-bottom: 0;
  text-align: center;
}

.footer {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: auto;
}

.widget-container {
  display: flex;
  flex-direction: column;
  margin: 0 50px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.header {
  width: 100%;
}

div.results-location {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.95);
  width: fit-content;
  left: 25px;
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  font-weight: 400;
}

div.results-location > div:last-of-type {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 15px;
}

div.results-details > div.contact > a {
  display: block;
  font-size: 16px;
}

div.results-details > div.contact > div.contact-text {
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.95);
  border-bottom: .25em solid #beaf87;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
}

div.results-details > div.contact > div.contact-text > button {
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 10px;
  color: #343534;
}

div.globalMessagesContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

div.globalMessagesContainer > div {
  color: $primary-color;
  background-color: lighten($primary-color, 65);
  border: 1px solid $primary-color;
  padding: 10px 15px;
  border-radius: 10px;
  margin-bottom: 5px;
}

div.globalMessagesContainer > div.error {
  color: $error-color;
  background-color: lighten($error-color, 65);
  border: 1px solid $error-color;
}

div.globalMessagesContainer > div.success {
  color: $green-color;
  background-color: lighten($green-color, 65);
  border: 1px solid $green-color;
}

div.isOwnerContainer {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

div.isOwnerContainer > p {
  margin: 0;
}

div.isOwnerContainer > div.options {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

div.isOwnerContainer > div.options > div.option {
  display: flex;
  gap: 15px;
  padding: 10px;
  align-items: center;
  border: 1px solid lightgray;
  border-radius: 5px;
  background-color: white;
  cursor: pointer;
  font-weight: 400;
}

div.isOwnerContainer > div.options > div.option:hover {
  border-color: gray;
  background-color: lightgray;
}

div.isOwnerContainer > div.options > div.option.selected {
  border-color: black;
  background-color: lightgray;
}

div.radioSelect {
  display: flex;
  flex-direction: column;
  gap: 5px;
  user-select: none;
}

div.radioSelect > div.options {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

div.radioSelect > div.options > div.option {
  display: flex;
  gap: 15px;
  align-items: center;
  width: auto;
  border: solid 1px lightgrey;
  padding: 15px;
  background: white;
  cursor: pointer;
}

div.radioSelect > div.options > div.option > svg {
  width: 30px;
}

div.radioSelect > div.options > div.option > svg > path {
  fill: black;
}

div.radioSelect > div.options > div.option.selected > svg > path, div.radioSelect > div.options > div.option:hover > svg > path  {
  fill: white;
}

div.radioSelect > div.options > div.option.selected, div.option:hover {
  border: solid 1px #343534;
  color: white;
}

div.radioSelect > div.options > div.option.selected {
  background-color: darken(lightgrey, 10%);
}

div.radioSelect > div.options > div.option:hover {
  background-color: lightgrey;
}

div.radioSelect > p {
  margin: 0;
  font-weight: 200;
}

div.streetNumberContainer {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

div.streetNumberContainer > div:first-of-type {
  flex: 4;
}

div.streetNumberContainer > div:last-of-type {
  flex: 1;
}

.disableSubtypeSelect {
  cursor: not-allowed;
}

.buttonLoading {
  cursor: wait !important;
}

@media only screen and (max-width: 650px) {
  div.widget-container {
    margin: 10px;
  }

  div.streetNumberContainer {
    flex-direction: column;
    gap: 20px;
  }

  div.results-map > div.results-details {
    flex-direction: column;
    justify-content: unset;
    align-items: unset;
    gap: 10px;
  }

  div.results-map > div.results-details > div.details {
    min-width: unset;
    min-height: unset;
  }

  div.results-map > div.results-details > h4 {
    font-weight: 600;
  }

  div.results-map > div.results-details > div:first-of-type, div.results-location {
    font-weight: 400;
  }

  div.results-map > div.results-details > div.contact {
    text-align: center;
    flex: 1;
  }

  div.results-details > div.details {
    gap: 5px;
  }

}

@media only screen and (max-width: 415px) {
  /* Styles for mobile devices with width equal to or smaller than 390px */
  div.radioSelect > div.options {
    flex-direction: column;
    gap: 15px;
  }

  div.results-details {
    flex-direction: column;
    justify-content: unset;
    align-items: unset;
  }
  div.results-details > div.details {
    gap: 10px;
  }

  div.results-location > div:nth-child(2) > div:nth-child(2) {
    display: none;
  }

  div.results-location > div:last-of-type {
    flex-direction: column;
    gap: 5px;
    font-size: 16px;
  }
}

@media screen and (min-width: 551px) {
  div.viewContainer {
    position: relative !important;
  }
}
</style>
